import styled from '@emotion/styled';

export const InsightsContainer = styled.div`
  width: 100%;
  padding-top: var(--sizes-50);
`;
